import React from 'react';
import { Col, Row, Button } from 'reactstrap';
import './EditorToggler.css';

export const EditorToggler = (props) => {
    const { icon, onToggle, color, dir, text } = props;
    const className = `editor-${dir}-toggler`;
    return (
        <Row className={`editor-${dir}-toggler-row`}>
            <Col>
                <Button className={className} onClick={onToggle} style={{ backgroundColor: color ? color : 'black' }} >
                    <i className={icon} style={{ color: '#fff', fontSize: '30px' }} />
                </Button>
            </Col>
        </Row>
    )
}
export const ContentToggler = (props) => {
    const { icon, onToggle, color, dir, text } = props;
    const className = `editor-${dir}-toggler`;
    return (
        <Button className={className} onClick={onToggle} style={{ backgroundColor: color ? color : 'black' }} >
            <i className={icon} style={{ color: '#fff', fontSize: '15px' }} />
        </Button>


    )
}